import store from './store/index'
// ie polyfill
import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { VueAxios } from './utils/request'
// mock
// 注意mock.js不支持IE，不要在生产环境`production`中使用.
import './mock'

import bootstrap from './core/bootstrap'
import './core/lazy_use'
import './permission' // permission control
import './utils/filter' // global filter
import 'ant-design-vue/dist/antd.less'
import i18n from './locales'

import axios from 'axios'
import Qs from 'qs'
import echarts from 'echarts'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)
// todo1
// user_type: 1, // 1 锁安  2 锁协
console.log(777777, location.host)
store.commit('getUserType', location.host == 'sx.mtwlockan.com' || location.host == 'lock.jsssyxh.com' ? 2 : 1)
document.title = location.host == 'sx.mtwlockan.com' || location.host == 'lock.jsssyxh.com' ? 'Jsssyxh' : 'Lockan Web'
// import VueAMap  from 'vue-amap';
Vue.config.devtools = true
// Vue.use(VueAMap );
Vue.config.productionTip = false

// mount axios Vue.$http and this.$http
Vue.use(VueAxios)

Vue.prototype.$axios = axios
Vue.prototype.qs = Qs

Vue.prototype.$echarts = echarts

// 初始化vue-amap
// VueAMap.initAMapApiLoader({
//   key: 'QzLsYPfsQwayd3pHG66IQmQKpmfqxaUH',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 默认高德 sdk 版本为 1.4.4
//
// });
Viewer.setDefaults({
  inline: false,
  button: true, // 右上角按钮
  navbar: false, // 底部缩略图
  title: false, // 当前图片标题
  toolbar: true, // 底部工具栏
  tooltip: true, // 显示缩放百分比
  movable: true, // 是否可以移动
  zoomable: true, // 是否可以缩放
  rotatable: true, // 是否可旋转
  scalable: true, // 是否可翻转
  transition: false, // 使用 CSS3 过度
  fullscreen: false, // 播放时是否全屏
  keyboard: true // 是否支持键盘
})
new Vue({
  router,
  store,
  i18n,
  created: bootstrap,
  render: h => h(App)
}).$mount('#app')
